import { setPopUpTop } from './popup'

function setupActionLinkListeners() {
  // Modal - Close popup
  $(document).on('click', "a[href='#close-popup'], [data-imagelink='#close-popup']", function () {
    $('.closeLPModal').trigger('click')

    return false
  })

  // Modal - Show popup
  $(document).on('click', "a[href='#open-popup'], [data-imagelink='#open-popup']", function () {
    const checkIfShowHide = $(this).parent().attr('data-elbuttontype')
    // TODO: Remove '2' when the rendering process is done through an external server.
    //  It's used to support the legacy code
    if (typeof checkIfShowHide == 'undefined' || !['2', 'showHide'].includes(checkIfShowHide)) {
      setPopUpTop()

      // check other videos (youtube/vimeo/wistia and auto play if true)
      // $('#' + $ID + ' .de-video-block .elVideo iframe').each(function (index, value) {
      //   $autoplaycheck = $(this).attr('data-popup-autoplay')

      //   if ($autoplaycheck == 'true') {
      //     $src = $(this).attr('src')
      //     $src = $src.replace('autoplay=0', 'autoplay=1')
      //     $src = $src.replace('autoPlay=0', 'autoPlay=1')
      //     $(this).attr('src', $src)
      //     $(this).attr('data-popup-autoplay', 'played')
      //   }
      // })
    }
    return false
  })

  // Print Page (webinars)
  $(document).on('click', "a[href='#print'], [data-imagelink='#print']", function () {
    window.print()

    return false
  })

  // Scroll To Block Area
  $(document).on('click', "a[href*='#scroll-'], [data-imagelink*='#scroll-']", function (evt) {
    const href = evt.currentTarget.getAttribute('href') ?? ''
    const [, id] = href?.split('#scroll-')

    if (id) {
      const $el = $(`.${id}`) as any
      $('html, body').animate({ scrollTop: $el.offset().top }, 500)
    }

    return false
  })

  const getElementsIds = (evt, type) =>
    (evt.currentTarget.getAttribute(`data-${type}-button-ids`) || '').split(',').filter((s) => s)

  const performActionOnId = (id, action) => {
    const $el = $(`.${id}`) as any

    $el[action](500)
  }

  // Show / Hide
  $(document).on('click', "a[href*='#show-hide'], [data-imagelink*='#show-hide']", function (evt) {
    evt.preventDefault()

    const hideIds = getElementsIds(evt, 'hide')
    const showIds = getElementsIds(evt, 'show')

    hideIds.forEach((id) => performActionOnId(id, 'fadeOut'))
    showIds.forEach((id) => performActionOnId(id, 'fadeIn'))

    return false
  })
}

window.addEventListener('load', setupActionLinkListeners)
